export class Issue {
    public __classname__: string = 'Issue';

    public Id : string | null = null;
	public NameId : string | null = null;
	public OverrulePublicationId : boolean | null = null;

    constructor(
        Id: string | null = null,
        NameId: string | null = null,
        OverrulePublicationId: boolean | null = null
    ) {
        this.Id = Id;
        this.NameId = NameId;
        this.OverrulePublicationId = OverrulePublicationId;
    }
}